/* Общие элементы управления: кнопки, поле поиска, бейдж счётчика.
   Подключаются в разделах как `ui`, чтобы кнопки везде были одинаковыми. */

.button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
  text-decoration: none;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.button:hover:not(:disabled) {
  border-color: var(--slate-lt);
}
.button:disabled {
  opacity: 0.6;
  cursor: default;
}

.primary {
  color: #fff;
  background: var(--blue);
  border-color: var(--blue);
}

.primary:hover:not(:disabled) {
  background: var(--blue-dark);
  border-color: var(--blue-dark);
}

.search {
  height: 36px;
  padding: 0 12px;
  font-size: 13.5px;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.search:focus {
  outline: none;
  border-color: var(--blue);
}

.count {
  display: inline-block;
  min-width: 22px;
  padding: 0 7px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  color: var(--text2);
  background: var(--border);
  border-radius: var(--r-pill);
  font-variant-numeric: tabular-nums;
}
